import { Pipe, PipeTransform, inject } from '@angular/core';

import { ThematicField, translateThematicField } from '../helpers/thematic-i18n.helper';
import { LocaleService } from '../services/locale.service';

@Pipe({ name: 'thematicField' })
export class ThematicFieldPipe implements PipeTransform {
  private readonly locale = inject(LocaleService);

  transform(
    fallback: string | undefined | null,
    slug: string | undefined | null,
    field: ThematicField = 'title',
  ): string {
    return translateThematicField(this.locale, slug ?? undefined, field, fallback ?? '');
  }
}
